<template>
  <v-container>
    <v-row class="flex-column justify-start pa-2" dense>
      <v-col class="text-h6">
        <div>Mon compte</div>
      </v-col>
      <v-divider class="pb-6" />

      <v-container ml-12 mt-10 class="text-body-2 mb-3 mx-3">
        <v-layout row wrap>
          <v-flex xs7>
            <v-layout>
              <v-flex class="font-weight-bold" md4>
                Numéro de client SAQ :
              </v-flex>
              <v-flex md6>
                {{ usagerConnecteInfosJDE.noClientJDE }}
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs7>
            <v-layout>
              <v-flex class="font-weight-bold" md4>
                Nom du client :
              </v-flex>
              <v-flex md6>
                {{ usagerConnecteInfosJDE.nom }}
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs7>
            <v-layout>
              <v-flex class="font-weight-bold" md4>
                Adresse :
              </v-flex>
              <v-flex md8>
                {{ usagerConnecteInfosJDE.adresse }},
                {{ usagerConnecteInfosJDE.ville }},
                {{ usagerConnecteInfosJDE.codePostal }}
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs7>
            <v-layout>
              <v-flex class="font-weight-bold" md4>
                Téléphone (établissement) :
              </v-flex>
              <v-flex md6>
                {{ usagerConnecteInfosJDE.noTelephoneBureau1 }}
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap mt-5>
          <v-flex xs7>
            <v-layout>
              <v-flex class="font-weight-bold" md4 mt-5>
                Nom d'utilisateur :
              </v-flex>
              <v-flex md6>
                <v-text-field
                  v-model.trim="codeUsager"
                  class="pr-3"
                  maxlength="128"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs7>
            <v-layout>
              <v-flex class="font-weight-bold" md4 mt-5>
                Nom du responsable :
              </v-flex>
              <v-flex md6>
                <v-text-field
                  v-model.trim="nomContact"
                  class="pr-3"
                  maxlength="128"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs7>
            <v-layout>
              <v-flex class="font-weight-bold" md4 mt-5>
                Adresse courriel :
              </v-flex>
              <v-flex md6>
                <v-text-field
                  v-model.trim="courrielContact"
                  class="pr-3"
                  maxlength="128"
                  @keyup.enter="submitModifier()"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap mt-3>
          <v-flex xs7>
            <v-layout>
              <v-flex class="font-weight-bold" md4>
                Mot de passe :
              </v-flex>
              <v-flex md6>
                <v-dialog
                  v-model="dialog"
                  persistent
                  max-width="600px"
                  @keydown.esc="annulerModificationMdp"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      medium
                      color="primary"
                      style="text-transform: none;"
                      v-on="on"
                    >
                      <v-icon left>mdi-pencil</v-icon>
                      {{ $t('profil_modifier_mdp_lien') }}
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="text-h5">{{
                        $t('profil_modifier_mdp_popup_titre')
                      }}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field
                              ref="ancienMotDePasse"
                              v-model="ancienMotDePasse"
                              :label="
                                $t('profil_modifier_mdp_popup_ancien_mdp')
                              "
                              :error-messages="ancienMotDePasseErrors"
                              :append-icon="
                                showPwd ? 'visibility' : 'visibility_off'
                              "
                              :type="showPwd ? 'text' : 'password'"
                              :disabled="sending"
                              @keyup.enter="submitModifierMdp"
                              @blur="$v.ancienMotDePasse.$touch()"
                              @click:append="showPwd = !showPwd"
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              v-model="motDePasse"
                              :label="
                                $t('profil_modifier_mdp_popup_nouveau_mdp')
                              "
                              :error-messages="motDePasseErrors"
                              :append-icon="
                                showPwd ? 'visibility' : 'visibility_off'
                              "
                              :type="showPwd ? 'text' : 'password'"
                              :disabled="sending"
                              @keyup.enter="submitModifierMdp"
                              @blur="$v.motDePasse.$touch()"
                              @click:append="showPwd = !showPwd"
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              v-model="confirmationMotDePasse"
                              :label="
                                $t('profil_modifier_mdp_popup_confirmation_mdp')
                              "
                              :error-messages="confirmationMotDePasseErrors"
                              :append-icon="
                                showPwd ? 'visibility' : 'visibility_off'
                              "
                              :type="showPwd ? 'text' : 'password'"
                              :disabled="sending"
                              @keyup.enter="submitModifierMdp"
                              @blur="$v.confirmationMotDePasse.$touch()"
                              @click:append="showPwd = !showPwd"
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                      <small
                        >*{{
                          $t('profil_modifier_mdp_popup_champs_requis')
                        }}</small
                      >
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        medium
                        color="primary"
                        style="text-transform: none;"
                        @click="annulerModificationMdp"
                        >{{ $t('profil_modifier_mdp_popup_annuler') }}</v-btn
                      >
                      <v-btn
                        medium
                        color="primary"
                        style="text-transform: none;"
                        class="white--text ml-5"
                        @click="submitModifierMdp"
                        >{{
                          $t('profil_modifier_mdp_popup_sauvegarder')
                        }}</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container ml-12 class="text-body-2 mb-3 mx-3">
        <v-layout row wrap>
          <v-flex xs7>
            <v-layout>
              <v-flex class="font-weight-bold" md4 mt-5>
                Langue de correspondance :
              </v-flex>
              <v-flex md6>
                <v-radio-group v-model="languePreferee" row>
                  <v-radio label="Français" value="fr" />
                  <v-radio label="Anglais" value="en" />
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-row>

    <v-row class="justify-center">
      <v-btn
        medium
        color="primary"
        style="text-transform: none;"
        class="white--text ml-5"
        @click="submitModifier()"
      >
        Enregistrer les changements
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import {
  required,
  minLength,
  maxLength,
  sameAs
} from 'vuelidate/lib/validators'
import moment from 'moment'
export default {
  name: 'Accueil',
  mixins: [validationMixin],
  data() {
    return {
      filtre: null,
      loading: false,
      ancienMotDePasse: '',
      motDePasse: '',
      confirmationMotDePasse: '',
      codeUsager: null,
      nomContact: null,
      courrielContact: null,
      languePreferee: null,
      showPwd: false,
      sending: false,
      dialog: false
    }
  },
  validations: {
    ancienMotDePasse: {
      required
    },
    motDePasse: {
      required,
      minLength: minLength(8),
      forceMotDePasse: mdp => {
        return /[a-z]/.test(mdp) && /[A-Z]/.test(mdp) && /[0-9]/.test(mdp)
      }
    },
    confirmationMotDePasse: {
      required,
      sameAs: sameAs('motDePasse')
    }
  },
  computed: {
    usagerConnecteInfosJDE: function() {
      return this.$store.getters.usagerConnecteInfosJDE
    },

    ancienMotDePasseErrors() {
      const errors = []
      if (!this.$v.ancienMotDePasse.$dirty) return errors
      !this.$v.ancienMotDePasse.required &&
        errors.push(this.$t('msg_obligatoire'))
      return errors
    },
    motDePasseErrors() {
      const errors = []
      if (!this.$v.motDePasse.$dirty) return errors
      !this.$v.motDePasse.required && errors.push(this.$t('msg_obligatoire'))
      !this.$v.motDePasse.minLength &&
        errors.push(this.$t('msg_lg_mini', { nb: 8 }))
      !this.$v.motDePasse.forceMotDePasse &&
        errors.push(this.$t('msg_mdp_regles'))
      return errors
    },
    confirmationMotDePasseErrors() {
      const errors = []
      if (!this.$v.confirmationMotDePasse.$dirty) return errors
      !this.$v.confirmationMotDePasse.required &&
        errors.push(this.$t('msg_obligatoire'))
      !this.$v.confirmationMotDePasse.sameAs &&
        errors.push(this.$t('msg_mdp_identique'))
      return errors
    }
  },

  beforeMount() {
    this.codeUsager = this.$store.getters.currentUser.clientData.usager.codeUsager
    this.nomContact = this.$store.getters.currentUser.clientData.nomContact
    this.courrielContact = this.$store.getters.currentUser.clientData.courrielContact
    this.languePreferee = this.$store.getters.currentUser.clientData.usager.languePreferee
  },

  methods: {
    annulerModificationMdp() {
      this.dialog = false
      this.ancienMotDePasse = ''
      this.motDePasse = ''
      this.confirmationMotDePasse = ''
      this.$v.$reset()
    },
    submitModifierMdp() {
      this.$store.dispatch('effacer')
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.modifierMotDePasse()
      }
    },
    modifierMotDePasse() {
      this.sending = true

      axios
        .put('/clients/mdp', {
          ancienMotDePasse: this.ancienMotDePasse,
          motDePasse: this.motDePasse
        })
        .then(response => {
          let resp = response.data
          switch (resp.codeRetour) {
            case 'OK':
              this.dialog = false
              this.annulerModificationMdp()
              this.$store.dispatch(
                'afficherSuccess',
                this.$t('profil_modifier_mdp_popup_succes')
              )
              break
            case 'S002':
              console.log('S002')
              this.$store.dispatch(
                'afficherError',
                this.$t('profil_modifier_mdp_popup_statut_invalide')
              )
              this.dialog = false
              this.annulerModificationMdp()
              break
            case 'S003':
              this.$store.dispatch(
                'afficherError',
                this.$t('profil_modifier_mdp_popup_ancienMdp_invalide')
              )
              this.ancienMotDePasse = ''
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
        .finally(() => {
          this.sending = false
        })
    },

    submitModifier() {
      console.log('submitModifier ')

      var email = /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/
      if (this.courrielContact.match(email) == null) {
        this.$store.dispatch(
          'afficherWarning',
          "Le courriel n'est pas un courriel valide"
        )
        return
      } else {
        this.modifier()
      }
    },

    modifier() {
      console.log('modifier le profil')

      if (this.codeUsager == '') {
        this.$store.dispatch(
          'afficherWarning',
          "Le nom d'utilisateur est obligatoire"
        )
        return
      }

      if (this.nomContact == '') {
        this.$store.dispatch(
          'afficherWarning',
          'Le nom du responsable est obligatoire'
        )
        return
      }

      if (this.courrielContact == '') {
        this.$store.dispatch(
          'afficherWarning',
          "L'adresse courriel est obligatoire"
        )
        return
      }

      this.$store.getters.currentUser.clientData.usager.codeUsager = this.codeUsager
      this.$store.getters.currentUser.clientData.nomContact = this.nomContact
      this.$store.getters.currentUser.clientData.courrielContact = this.courrielContact
      this.$store.getters.currentUser.clientData.usager.languePreferee = this.languePreferee

      axios
        .put('/clients/', this.$store.getters.currentUser.clientData)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.$store.dispatch(
                'afficherSuccess',
                'Les informations ont été modifiées avec succès'
              )
              break
            case 'V002':
              this.$store.dispatch(
                'afficherWarning',
                'Veuillez choisir un autre code usager'
              )
              break
            case 'V003':
              this.$store.dispatch(
                'afficherWarning',
                'Veuillez choisir un autre code usager'
              )
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    }
  }
}
</script>

<style scoped>
fieldset {
  display: block;
  margin-left: 0px;
  margin-right: 0px;
  padding: 0px;
  padding-bottom: 1em;
  padding-left: em;
  border: 1px solid black;
  border-radius: 10px;
}
</style>
